import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import SimpleSelectionTable, { SimpleFilterField } from '../../../../components/datatable/SimpleSelectionTable'
import { DefaultDialogTitle } from '../../../../components/styled/Dialog'
import { normalizeString } from '../../../../utils/StringUtil'

const HEADERS_STATIONS = ['code', 'name']

const filterFunction = (list, { searchValue = '' }) => {
    const searchValueFormat = normalizeString(searchValue)
    return searchValue ? list.filter(s => normalizeString(`${s.code ?? ''} ${s.name ?? ''}`).includes(searchValueFormat)) : list
}

const DialogStations = ({
    open = false,
    title = '',
    onClose = () => {},
    onValidate = () => {},

    stations = [],
    selectedStations = [],
    setSelectedStations = () => {},
}) => (
    <Dialog open={open} maxWidth='lg'>
        <DefaultDialogTitle title={title} onClose={onClose} />
        <DialogContent>
            <SimpleSelectionTable
                listHeaders={HEADERS_STATIONS}
                listTitle={i18n.stationList}
                selectedListTitle={i18n.selectedStations}

                listData={stations}
                selectedList={selectedStations}

                onChange={setSelectedStations}

                filterField={SimpleFilterField}
                filterFunction={filterFunction}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={onValidate} variant='contained' color='primary'>
                {i18n.validate}
            </Button>
        </DialogActions>
    </Dialog>
)

DialogStations.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    // id = code de la station : c'est le code qui est stocké dans lien_stations
    stations: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        code: PropTypes.string,
        name: PropTypes.string,
    })),
    selectedStations: PropTypes.arrayOf(PropTypes.string),
    setSelectedStations: PropTypes.func,
}

export default DialogStations
